import { useMutation, useQuery } from "@apollo/client";
// import { CreateCommentMutation, CreateCommentMutationVariables, 
//          DeleteCommentMutation, DeleteCommentMutationVariables, 
//          GetPostQuery, GetPostQueryVariables, Post, 
//          UpdateCommentMutation, UpdateCommentMutationVariables, 
//          UpdatePostMutation, UpdatePostMutationVariables } from "../../API";
import { createAgendaPostByComId, getAgendaCompany, updateAgendaPost } from "./queries";
import { useAuthContext } from "../../../contexts/AuthContext";
import { CreateAgendaPostByComIdMutation, CreateAgendaPostByComIdMutationVariables,
  GetAgendaCompanyQuery, GetAgendaCompanyQueryVariables, UpdateAgendaPostMutation, 
  UpdateAgendaPostMutationVariables } from "../../../graphql/API";
import { v4 as uuidv4 } from 'uuid';
// import messaging from '@react-native-firebase/messaging';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useNavigate } from "react-router-dom";
import TopicNotificationService from "../TopicService";
import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidV4 } from 'uuid';
import { useTranslation } from "react-i18next";

const usePostService = (comId: string, postId: string | null, image: string | null | undefined, username: string | null | undefined, FCMToken: string | null | undefined) => { //, postId: string | null) => {
    // AUTH  
    const {userId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    // NAVIGATION
    const navigate = useNavigate();
    // NOTIFICATION
    const {sendTopicNotification} = TopicNotificationService();

    const [doCreatePost] = useMutation<CreateAgendaPostByComIdMutation, CreateAgendaPostByComIdMutationVariables>(createAgendaPostByComId);

    const [doDeletePost] = useMutation<UpdateAgendaPostMutation, UpdateAgendaPostMutationVariables>(updateAgendaPost, {refetchQueries: ['PostsByCompany']});

    const truncate = (str: string | undefined, maxlength: number) => {
      if (str) {
        return (str.length > maxlength) ?
        str.slice(0, maxlength - 1) + '…' : str;
      } else {
        return str;
      }
    };

    // const sendPostNotification = async (
    //   title: string | undefined, 
    //   description: string | undefined, 
    //   postId: string | null | undefined,
    //   receiverId: string | null | undefined) => {
    //   // await messaging().unsubscribeFromTopic("posts");
    //   // if (!receiverId) {
    //   //   await messaging().unsubscribeFromTopic(comId +"_posts");
    //   // }
    //   // await messaging().unsubscribeFromTopic("posts");

    //   var uri = 'https://schedulum.org/api/FCM/notification/';
    //   // var uri = 'http://192.168.9.234:8000/api/FCM/notification/';
    //   const form_data = new FormData();
    //   const mobile_auth = "Schedulum-auth-key-ki%@1293ij9j23$as";
    //   form_data.append("mobile_auth", mobile_auth);
    //   form_data.append("title", title);
    //   form_data.append("body", description);
    //   form_data.append("type", "post");
    //   form_data.append("senderId", userId);
    //   form_data.append("id", postId);
    //   form_data.append("startAt", null);
    //   form_data.append("stopAt", null);
    //   // form_data.append("data", JSON.stringify({ type: "post", senderId: userId }));
    //   form_data.append("topic", receiverId ? receiverId : comId+"_posts"); //"posts");
    //   // console.log(form_data);
    //   try {
    //     const response = await fetch(uri, {
    //       method: "POST",
    //       body: form_data,
    //       headers: {},
    //     });
    //     const res = await response.json();
    //     console.log(res);
    //     if (res.status === "success") {
    //       // return res.message;
    //       console.log("Notification envoyée avec succès.");
    //     } else {
    //       console.log("Erreur d'envoi :", res.message);
    //     }
    //   } catch (err) {
    //     console.log("Erreur FCM :", err);
    //     if (err instanceof Error) {
    //       console.error("Message d'erreur:", err.message);
    //     }
    //   }

    //   // if (!receiverId) {
    //   //   // subscribe again
    //   //   setTimeout(async () => {
    //   //     // await messaging().subscribeToTopic("posts");
    //   //     await messaging().subscribeToTopic(comId+"_posts");
    //   //   }, 5000); // Réinscription après 5s
    //   // }
    // }

    const generateCustomId = () => {
      const prefix = "Post";
      const uniquePart = uuidv4();
      return `${prefix}-${uniquePart}`;
    };

    const createPostContent = async (newPost: string, room: string, postId: string, receiverId?: string | null) => {
      try {
          // console.log('ok',image);
          const date = new Date();
          const now = date.toISOString();
          const postId = generateCustomId();
          await doCreatePost({
            variables: {
                postId: postId,
                comId: comId,
                description: newPost,
                userId: userId,
                room,
                image: image ? image : "",
                username: username,
                //owner: userId,
                deleted: false,
                updatedAt: now,
                createdAt: now,
                // __typename: 'AgendaPost',

              // input: {
              //     postId: postId,
              //     comId: comId,
              //     description: newPost,
              //     userId: userId,
              //     //owner: userId,
              //     deleted: false,
              //     // description: newComment,          
              // },
            },
          });
          // console.log('yeah', receiverId);
          // incrementNofComments(1);
          // navigation.navigate('Posts', {refetchPost: true, comId: comId, readedAt: new Date()})
          // refetch();
          if (username && newPost) {
            // sendPostNotification(truncate(username, 20), truncate(newPost, 20), postId, receiverId);
            // title: string | undefined, 
            // description: string | undefined, 
            // FCMtoken: string | undefined, 
            // receiverId: string | undefined,
            // dataId: string | null | undefined,
            // startAt: string | null | undefined,
            // stopAt: string | null | undefined,
            // type: string
            sendTopicNotification(truncate(username, 20), truncate(newPost, 20), undefined, postId, receiverId, null, null, "post", receiverId ? receiverId : comId+"_posts");
          }
      } catch(error) {
          alert("Error Creating a comment: " + (error as Error).message);
          console.log((error as Error).message);
      };
    };

    const onCreatePost = async (newPost: string, room: string, receiverId?: string | null, asset?: File | null) => {
      const postId = generateCustomId();
      // empty post
      if (newPost == '' || newPost == null || newPost == undefined) {
        // with asset
        if (asset) {
          const path = await uploadMedia(asset, postId);
          await createPostContent("<!*!_IMG_!*!>" + path, room, postId, receiverId);
        // without asset
        } else {
          alert("Error Creating a post: It can't be empty");
          return;
        }
      // non empty post
      } else {
        // with asset
        if (asset) {
            const path =  await uploadMedia(asset, postId);
            await createPostContent("<!*!_IMG_!*!>" + path, room, postId, receiverId);
        }
        const textPostId = generateCustomId();
        await createPostContent(newPost, room, textPostId, receiverId);
      }
    };

    const uploadMedia = async (file: File, postId: string) => {
      // try {
      //     if (user?.image) {
      //       await remove({ key: user?.image }); //, options: { accessLevel: 'protected' } });
      //     };
      // } catch (error) {
      //     Alert.alert("Failed to delete your avatar", (error as Error).message);
      // };
      try {
          // const fileName = `${uuidV4()}.${data.name.split('.').pop()}`;
          const uriParts = file.name.split('.');
          const extension = uriParts[uriParts.length - 1];
          const fileName = `${uuidV4()}.${extension}`;
          const name = file.name;
          const type = file.type;
          const key = `${comId}/${userId}/posts/${postId}/${fileName}`;
          const result = await uploadData({
              path: `public/${key}`,
              data: file,
          }).result;
          return key;
      } catch (error) {
          alert(t('profile.error_uploading_image') + " :" + (error as Error).message);
      };
    };

    // const incrementNofComments = (amount: 1 | -1) => {
    //   if (!post) {
    //     Alert.alert("Failed to fetch post, try again later");
    //     return;
    //   };
    //   doUpdatePost({
    //     variables: {
    //       input: {
    //         id: post?.id,
    //         nofComments: (post?.nofComments || 0) + amount,
    //       }
    //     }
    //   })
    // };

    //   const post = postData?.getAgendaPost;
      const onDeletePost = async (userId?: string) => {
        if (!postId) {
          alert("Failed to fetch post, try again later");
          return;
        };
        try {
          //await doDeleteComment({variables: {input: {id: commentId}}, refetchQueries: ['CommentsByPost']});
          await doDeletePost({
            variables: {
              input: {
                  postId: postId,
                  deleted: true,         
              },
            },
          });
          // incrementNofComments(-1);
          // refetch();
          // navigate('/posts')
          if (userId) {
            // navigate(`/posts/${userId}`, { state: { deleted: postId }, replace: true });
            window.location.href = `/posts/${userId}`;
          } else {
            // navigate('/posts', { state: { deleted: postId } });
            window.location.href = '/posts';
          }
        } catch(error) {
            alert("Error Deleting a post: " + (error as Error).message);
        };
      };
   

    return {
      onCreatePost, onDeletePost,
    };


};

export default usePostService;